// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Translations
import {withTranslation} from "react-i18next";
// Components
import { Dialog} from "@material-ui/core";
import {Button} from "@components/Input";
// Assets
import {chargebeeInfoSvg, chargebeeArrowSvg, closeSvg} from "assets";
// Styles
import "../styles/styles.scss";
// Chargebee
import { ChargebeeAPI } from "views/Chargebee/infrastructure";
import { ChargebeeAPI as CommonsChargebeeAPI } from "@api/Chargebee";


class ChargebeeUpdateCheckout extends Component {
    constructor(props) {
        super(props);

        let chargebeeSubscription = this.props.data.plan.chargebee_plans.filter(s => !s.is_dummy)[0];

        this.state = {
            checkout: false,
            redirection: false,

            chargebeeSubscription: chargebeeSubscription,
            frequency: chargebeeSubscription.frequency,
            currency: chargebeeSubscription.currency,

            plan_id: this.props.plan,

            cbInstance: window.Chargebee.init({
                site: this.props.data.user.chargebee_customer_site
            })
        };
    }

    handleChargebeeChange = (property, value) => {
        this.setState({
            ...this.state, [property]: value
        });
    };

    handleChargebee = async () => {
        const {access, user} = this.props.data;

        if (this.state.chargebeeSubscription?.chargebee_subscription_status === "in_trial" ||
            this.state.chargebeeSubscription?.frequency === this.state.frequency) {

            await this.state.cbInstance.setPortalSession(() => {
                let data = JSON.stringify({chargebee_customer_id: user.chargebee_customer_id});
                let chargebee_api = new CommonsChargebeeAPI(user.id, access, this.props, data);
                return chargebee_api.get_chargebee_user_portal();
            });

            this.state.cbInstance.createChargebeePortal().openSection({
                sectionType: window.Chargebee.getPortalSections().SUBSCRIPTION_DETAILS,
                params: {
                    subscriptionId: this.state.chargebeeSubscription.chargebee_subscription_id
                }
            });

        } else {

            this.state.cbInstance.openCheckout({
                hostedPage: () => {
                    let data = JSON.stringify({
                        chargebee_product_id: `${this.state.plan_id}-${this.state.currency}-${this.state.frequency}`,
                        chargebee_customer_id: user.chargebee_customer_id,
                        chargebee_subscription_id: this.state.chargebeeSubscription.chargebee_subscription_id
                    });
                    let chargebee_api = new ChargebeeAPI(user.id, access, this.props, data);
                    return chargebee_api.get_chargebee_hosted_page();
                },
                success: () => {
                    this.handleDialogAction("redirection", true);
                    this.state.cbInstance.closeAll();
                },
            });

        }

        this.handleDialogAction("checkout", false);

    };

    handleDialogAction = (dialog, action) => {
        this.setState({[dialog]: action});
    };

    handleRedirection = () => {
        window.location.href = process.env.REACT_APP_URL_CENTRIBOT;
    };

    render() {
        const {t, text} = this.props;
        const {checkout, redirection} = this.state;
        const in_trial = this.state.chargebeeSubscription.chargebee_subscription_status === "in_trial";
        return (
            <React.Fragment>
                <Button type={"pro"} onClick={() => this.handleDialogAction("checkout", true)} text={text} />
                <Dialog className={"chargebee_modal"} open={checkout}>
                    <div className={"chargebee_modal_close"} onClick={() => this.handleDialogAction("checkout", false)}>{closeSvg()}</div>
                    <div className={"chargebee_modal_header"}>
                        <img alt="centribal-chargebee" src={process.env.PUBLIC_URL + "/centribal_chargebee.png"}/>
                        <span>{t("checkout.title")}</span>
                    </div>
                    <div className={"chargebee_modal_content"}>
                        <div className={"content_element"}>
                            <div className={"content_element_title"}>
                                <span>{t("checkout.periodicity")}</span>
                                <span></span>
                            </div>
                            <div className={`content_element_option ${in_trial ? "in_trial" : ""}`}>
                                <span className={this.state.frequency === "Yearly" ? "selected" : ""} onClick={() => this.handleChargebeeChange("frequency", "Yearly")}>{t("checkout.frequency.yearly")}</span>
                                <span className={this.state.frequency === "Monthly" ? "selected" : ""}  onClick={() => this.handleChargebeeChange("frequency", "Monthly")}>{t("checkout.frequency.monthly")}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"chargebee_modal_actions"}>
                        <div>
                            {chargebeeInfoSvg()}
                            <span>{`${in_trial ? t("checkout.update.trial.info") : ""} ${t("checkout.update.info")}`}</span>
                        </div>
                        <button onClick={() => this.handleChargebee()}>
                            <span>{t("checkout.action")} {chargebeeArrowSvg()}</span>
                        </button>
                    </div>
                </Dialog>
                <Dialog className={"chargebee_modal"} open={redirection}>
                    <div className={"chargebee_modal_header"}>
                        <img alt="centribal-chargebee" src={process.env.PUBLIC_URL + "/centribal_chargebee.png"}/>
                        <span>{t("checkout.update.success.header")}</span>
                    </div>
                    <div className={"chargebee_modal_actions"}>
                        <div>
                            {chargebeeInfoSvg()}
                            <span>{t("checkout.update.success.info")}</span>
                        </div>
                        <button onClick={() => this.handleRedirection()}>
                            <span>{t("checkout.update.success.action")} {chargebeeArrowSvg()}</span>
                        </button>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(ChargebeeUpdateCheckout);

export default withTranslation("plans")(withRouter(connect_));